export const HOUSE_ROT = {
  nickname: 'PRODUCTS.HOUSE_ROT.nickname',
  icon:'house-rot'
};
